import { type SearchChildrenRequest } from "./request";

type ChildrenKeysListArgs = {
  groupName?: string;
};

export const childrenKeys = {
  all: ["children"] as const,
  lists: () => [...childrenKeys.all, "list"] as const,
  list: (params?: ChildrenKeysListArgs) =>
    params
      ? ([...childrenKeys.lists(), params] as const)
      : childrenKeys.lists(),
  search: (params?: SearchChildrenRequest["query"]) =>
    [...childrenKeys.all, "search", params] as const,
  details: () => [...childrenKeys.all, "detail"] as const,
  detail: (id: string) => [...childrenKeys.details(), id] as const
};
